<div class="holes-load-list-container">
  <div class="search-section">
    <div class="search-container">
      <div class="search-input-wrapper">
        <input
          type="text"
          class="input-text"
          [placeholder]="'QAQC_TAB.SEARCH_HOLES' | translate"
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          >
          @if (searchTerm) {
            <button
              class="clear-search-btn"
              (click)="clearSearch()"
              [title]="'QAQC_TAB.CLEAR_SEARCH' | translate"
              >
              <i class="fas fa-times"></i>
            </button>
          }
        </div>
        <div class="button-group">
          <button class="primary-button" (click)="onAddHole()" [title]="'QAQC_TAB.ADD_HOLE' | translate">
            <img src="assets/icon/add-circle.svg" alt="" />
            {{ 'QAQC_TAB.ADD_HOLE' | translate }}
          </button>
        </div>
      </div>
    </div>

    @if (filteredHoles && filteredHoles.length > 0) {
      <div class="holes-cards" #holesContainer>
        @for (hole of filteredHoles; track trackByHoleId($index, hole)) {
          <div
            class="hole-card"
            [class.expanded]="!isHoleExpanded(hole.holeId)"
            [attr.data-hole-id]="hole.holeId"
            >
            <div class="hole-header" (click)="toggleHole(hole.holeId)">
              <div class="hole-title">
                <span class="hole-name">Hole {{ hole.name }}</span>
              </div>
              <div class="expand-icon">
                <img
                  [src]="isHoleExpanded(hole.holeId) ? 'assets/icon/arrow-up.svg' : 'assets/icon/arrow-down.svg'"
                  [alt]="isHoleExpanded(hole.holeId) ? ('QAQC_TAB.COLLAPSE' | translate) : ('QAQC_TAB.EXPAND' | translate)"
                  class="expand-arrow"
                  >
                </div>
              </div>
              @if (isHoleExpanded(hole.holeId)) {
                <div class="hole-content">
                  <div class="section">
                    <div class="section-header" (click)="toggleSection(hole.holeId, 'state')">
                      <h6 class="section-title">{{ 'QAQC_TAB.STATE' | translate }}</h6>
                      <div class="section-expand-icon">
                        <img
                          [src]="isSectionExpanded(hole.holeId, 'state') ? 'assets/icon/arrow-up.svg' : 'assets/icon/arrow-down.svg'"
                          [alt]="isSectionExpanded(hole.holeId, 'state') ? ('QAQC_TAB.COLLAPSE' | translate) : ('QAQC_TAB.EXPAND' | translate)"
                          class="expand-arrow"
                          >
                        </div>
                      </div>
                      @if (isSectionExpanded(hole.holeId, 'state')) {
                        <div class="section-content">
                          <div class="status-history-two-columns">
                            @for (status of getHoleStatusHistory(hole); track status) {
                              <div
                                class="status-item"
                                >
                                <img [src]="getStatusSvgPath(status)" alt="{{ status }}" class="status-icon">
                                <span class="status-text">{{ status }}</span>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                    <div class="section">
                      <div class="section-header" (click)="toggleSection(hole.holeId, 'bulk')">
                        <div class="section-title-with-icon">
                          @if (shouldShowQualityIcon() && hole.plannedTotalBulk > 0 && hole.measuredTotalBulk > 0) {
                            <div
                              class="quality-circle"
                              [class]="getBulkQualityClass(hole)"
                            ></div>
                          }
                          <h6 class="section-title">{{ 'QAQC_TAB.BULK_EXPLOSIVES' | translate }} (Kg)</h6>
                        </div>
                        <div class="section-expand-icon">
                          <img
                            [src]="isSectionExpanded(hole.holeId, 'bulk') ? 'assets/icon/arrow-up.svg' : 'assets/icon/arrow-down.svg'"
                            [alt]="isSectionExpanded(hole.holeId, 'bulk') ? ('QAQC_TAB.COLLAPSE' | translate) : ('QAQC_TAB.EXPAND' | translate)"
                            class="expand-arrow"
                            >
                          </div>
                        </div>
                        @if (isSectionExpanded(hole.holeId, 'bulk')) {
                          <div class="section-content two-columns">
                            @if (!this.blast.isSimpleLoading) {
                              <div class="info-column">
                                <span class="label-span">{{ 'QAQC_TAB.PLANNED' | translate }}</span>
                                {{ hole.plannedTotalBulk | number: '1.2-2' }}
                              </div>
                            }
                            <div class="info-column">
                              <span class="label-span">{{ 'QAQC_TAB.MEASURED' | translate }}</span>
                              {{ hole.measuredTotalBulk | number: '1.2-2' }}
                            </div>
                          </div>
                        }
                      </div>
                      <div class="section">
                        <div class="section-header" (click)="toggleSection(hole.holeId, 'steaming')">
                          <div class="section-title-with-icon">
                            @if (shouldShowQualityIcon() && hole.plannedSteaming > 0 && hole.measuredSteaming > 0) {
                              <div
                                class="quality-circle"
                                [class]="getSteamingQualityClass(hole)"
                              ></div>
                            }
                            <h6 class="section-title">{{ 'QAQC_TAB.STEMMING' | translate }} (m)</h6>
                          </div>
                          <div class="section-expand-icon">
                            <img
                              [src]="isSectionExpanded(hole.holeId, 'steaming') ? 'assets/icon/arrow-up.svg' : 'assets/icon/arrow-down.svg'"
                              [alt]="isSectionExpanded(hole.holeId, 'steaming') ? ('QAQC_TAB.COLLAPSE' | translate) : ('QAQC_TAB.EXPAND' | translate)"
                              class="expand-arrow"
                              >
                            </div>
                          </div>
                          @if (isSectionExpanded(hole.holeId, 'steaming')) {
                            <div class="section-content two-columns">
                              @if (!this.blast.isSimpleLoading) {
                                <div class="info-column">
                                  <span class="label-span">{{ 'QAQC_TAB.PLANNED' | translate }}</span>
                                  {{ hole.plannedSteaming | number: '1.2-2' }}
                                </div>
                              }
                              <div class="info-column">
                                <span class="label-span">{{ 'QAQC_TAB.MEASURED' | translate }}</span>
                                {{ hole.measuredSteaming | number: '1.2-2' }}
                              </div>
                            </div>
                          }
                        </div>
                        <div class="section">
                          <div class="section-header" (click)="toggleSection(hole.holeId, 'linear')">
                            <div class="section-title-with-icon">
                              @if (shouldShowQualityIcon() && hole.plannedLinearQt > 0 && hole.measuredLinearQt > 0) {
                                <div
                                  class="quality-circle"
                                  [class]="getLinearQtQualityClass(hole)"
                                ></div>
                              }
                              <h6 class="section-title">{{ 'QAQC_TAB.LINEAR_QT' | translate }} (kg/m)</h6>
                            </div>
                            <div class="section-expand-icon">
                              <img
                                [src]="isSectionExpanded(hole.holeId, 'linear') ? 'assets/icon/arrow-up.svg' : 'assets/icon/arrow-down.svg'"
                                [alt]="isSectionExpanded(hole.holeId, 'linear') ? ('QAQC_TAB.COLLAPSE' | translate) : ('QAQC_TAB.EXPAND' | translate)"
                                class="expand-arrow"
                                >
                              </div>
                            </div>
                            @if (isSectionExpanded(hole.holeId, 'linear')) {
                              <div class="section-content two-columns">
                                @if (!this.blast.isSimpleLoading) {
                                  <div class="info-column">
                                    <span class="label-span">{{ 'QAQC_TAB.PLANNED' | translate }}</span>
                                    {{ hole.plannedLinearQt | number: '1.2-2' }}
                                  </div>
                                }
                                <div class="info-column">
                                  <span class="label-span">{{ 'QAQC_TAB.MEASURED' | translate }}</span>
                                  {{ hole.measuredLinearQt | number: '1.2-2' }}
                                </div>
                              </div>
                            }
                          </div>
                          <div class="section">
                            <div class="section-header" (click)="toggleSection(hole.holeId, 'cartridges')">
                              <h6 class="section-title">{{ 'QAQC_TAB.CARTRIDGES' | translate }}</h6>
                              <div class="section-expand-icon">
                                <img
                                  [src]="isSectionExpanded(hole.holeId, 'cartridges') ? 'assets/icon/arrow-up.svg' : 'assets/icon/arrow-down.svg'"
                                  [alt]="isSectionExpanded(hole.holeId, 'cartridges') ? ('QAQC_TAB.COLLAPSE' | translate) : ('QAQC_TAB.EXPAND' | translate)"
                                  class="expand-arrow"
                                  >
                                </div>
                              </div>
                              @if (isSectionExpanded(hole.holeId, 'cartridges')) {
                                <div class="section-content two-columns">
                                  @if (!this.blast.isSimpleLoading) {
                                    <div class="info-column">
                                      <span class="label-span">{{ 'QAQC_TAB.PLANNED' | translate }}</span>
                                      {{ hole.plannedCartridges | number: '1.0-0' }}
                                    </div>
                                  }
                                  <div class="info-column">
                                    <span class="label-span">{{ 'QAQC_TAB.MEASURED' | translate }}</span>
                                    {{ hole.measuredCartridges | number: '1.0-0' }}
                                  </div>
                                </div>
                              }
                            </div>
                            <div class="section">
                              <div class="section-header" (click)="toggleSection(hole.holeId, 'feature')">
                                <h6 class="section-title">{{ 'QAQC_TAB.FEATURE' | translate }}</h6>
                                <div class="section-expand-icon">
                                  <img
                                    [src]="isSectionExpanded(hole.holeId, 'feature') ? 'assets/icon/arrow-up.svg' : 'assets/icon/arrow-down.svg'"
                                    [alt]="isSectionExpanded(hole.holeId, 'feature') ? ('QAQC_TAB.COLLAPSE' | translate) : ('QAQC_TAB.EXPAND' | translate)"
                                    class="expand-arrow"
                                    >
                                  </div>
                                </div>
                                @if (isSectionExpanded(hole.holeId, 'feature')) {
                                  <div class="section-content two-columns">
                                    <div class="info-column checkbox-column">
                                      <label class="checkbox-label">
                                        <input type="checkbox" [checked]="hole.hasWater" disabled>
                                        <span class="checkmark"></span>
                                        {{ 'QAQC_TAB.WATER' | translate }}
                                      </label>
                                    </div>
                                  </div>
                                }
                              </div>
                              <div class="section">
                                <div class="section-header" (click)="toggleSection(hole.holeId, 'comment')">
                                  <h6 class="section-title">{{ 'QAQC_TAB.COMMENT' | translate }}</h6>
                                  <div class="section-expand-icon">
                                    <img
                                      [src]="isSectionExpanded(hole.holeId, 'comment') ? 'assets/icon/arrow-up.svg' : 'assets/icon/arrow-down.svg'"
                                      [alt]="isSectionExpanded(hole.holeId, 'comment') ? ('QAQC_TAB.COLLAPSE' | translate) : ('QAQC_TAB.EXPAND' | translate)"
                                      class="expand-arrow"
                                      >
                                    </div>
                                  </div>
                                  @if (isSectionExpanded(hole.holeId, 'comment')) {
                                    <div class="section-content">
                                      <div class="comment-area">
                                        @for (comment of hole.comments; track comment) {
                                          <div class="comment-item">
                                            {{ comment }}
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }

                    @if (!filteredHoles || filteredHoles.length === 0) {
                      <div class="no-holes">
                        @if (searchTerm) {
                          <div>
                            <p>{{ 'QAQC_TAB.NO_HOLES_FOUND' | translate }} "{{ searchTerm }}"</p>
                          </div>
                        } @else {
                          <p>{{ 'QAQC_TAB.NO_HOLES_DATA' | translate }}</p>
                        }
                      </div>
                    }
                  </div>